<template>
  <div>
    <PlotChange
      v-if="plot"
      :novel-id="novelId"
      :plotId="effectivePlotId"
      :plot="plot"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import PlotChange from "@/components/organisms/PlotChange.vue";
import { Plot, SubPlot } from "@/lib/models/plot";
import clone from "lodash/cloneDeep";
import { isOverallPlotRouteId } from "@/lib/utils/deepLink";

export default Vue.extend<Data, Methods, Computed, Props>({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
  components: { PlotChange },
  props: {
    novelId: String,
    plotId: String,
  },
  async created() {
    await this.$store.dispatch("plotModule/initialize", this.novelId);
  },
  computed: {
    plot() {
      const { $store, plotId } = this;

      if (!isOverallPlotRouteId(plotId)) {
        return clone($store.getters["plotModule/subPlot"](plotId));
      }
      return clone($store.getters["plotModule/plots"]);
    },
    effectivePlotId() {
      return isOverallPlotRouteId(this.plotId) ? undefined : this.plotId;
    },
  },
});

interface Props {
  novelId: string;
  plotId?: string;
}

interface Data {}

interface Computed {
  plot: Plot | SubPlot | null;
  effectivePlotId: string | undefined;
}

interface Methods {}
</script>
